import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RestService } from 'src/app/services/rest.service';
import { GlobalvarsService } from 'src/app/services/globalvars.service';

@Component({
  selector: 'app-scenarios',
  templateUrl: './scenarios.component.html',
  styleUrls: ['./scenarios.component.css']
})
export class ScenariosComponent implements OnInit {

  scenarios: any[] = [];

  constructor(
    private rest: RestService,
    private globalvar: GlobalvarsService,
    private router: Router
  ) { }

  ngOnInit(): void {
    let tmpToken:any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    this.rest.getScenarios(tmpToken.accessToken)
      .then(value => {
        this.scenarios.push(value)
      })
      .catch(err => {
        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })
  }

  edit(itemId: any) {
    this.router.navigateByUrl('/scenarios/' + itemId);
  }

  add() {
    this.router.navigateByUrl('/scenarios/add/');
  }
}
